export class Geocoder {
    constructor(provider, settings) {
        this.provider = provider;
        this.forwardPreprocessor = settings === null || settings === void 0 ? void 0 : settings.forwardPreprocessor;
    }
    reverseGeocode(l, callback) {
        this.provider.reverse(l, callback);
    }
    async geocode(query) {
        var _a;
        if (this.forwardPreprocessor) {
            query = this.forwardPreprocessor(query);
        }
        query.string = (_a = query.string) !== null && _a !== void 0 ? _a : "";
        query.string = query.string.trim();
        if (typeof this.abortController !== "undefined") {
            this.abortController.abort();
        }
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        if (query.string.length == 0) {
            return [];
        }
        return await this.provider.forward(query, {
            signal: signal
        });
    }
}
